import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SvgImages } from "../../Utils/LocalImages";
import { ConfirmationModalTheme, ImageFilters } from "../../Utils/Enums";
import { toast } from "react-toastify";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import Image from "../../Components/Reusable/Image";
import ConfirmationModal from "../../Components/modal/ConfirmationModal";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import RoutesPath from "../../Utils/RoutesPath";
import { Modal, ModalBody } from "react-bootstrap";
import { FileUploader } from "react-drag-drop-files";
import ApiConstants from "../../Utils/ApiConstant";
import { handleApiErrors } from "../../Utils/Utils";
import ClassService from "../../Services/ClassService";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputType, validationRegex } from "../../Utils/Utils";
import * as yup from "yup";
import { AuthContext } from "../../Context/authContext";
import AuthService from "../../Services/AuthService";
import DynamicService from "../../Services/DynamicService";

const ViewStudents = () => {
  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showResendCredentialsModal, setShowResendCredentialsModal] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [getStatusChangeData, setStatusChangeData] = useState({});
  const [offset, setOffset] = useState(0);
  const [limit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState(null);
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedMedium, setSelectedMedium] = useState("");
  const [studyMaterial, setStudyMaterial] = useState({});
  const [resetSubject, setResetSubject] = useState(false);
  const [selectedQuestionsCount, setSelectedQuestionsCount] = useState(0);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext)
  const [details, setDetails] = useState(null);

  const stepOneValidations = yup.object().shape({
    class_id: validationRegex.required,
    subject: validationRegex.required,
    medium: validationRegex.required
  });
  const { register: registerStepOne, handleSubmit: handleSubmitStepOne, setValue: setValuesStepOne, formState: { errors: errorsStepOne }, watch: watchStepOne, getValues: getValuesStepOne, reset: resetStepOne } = useForm({
    resolver: yupResolver(stepOneValidations),
    defaultValues: {
      class_id: studyMaterial ? studyMaterial?.class_id : "",
      subject: studyMaterial ? studyMaterial?.subject_id : "",
      medium: studyMaterial ? studyMaterial?.medium : "",
    },
  });



  const getAllClasses = async () => {
    try {
      const response = await ClassService.getAllClassesWithoutPagination();
      setClasses(response.data);

    } catch (error) {
      handleApiErrors(error);
    }
  };


  useEffect(() => { getAllClasses() }, []);

  const fetchData = async () => {
    try {
      const response = await AuthService.getAllUsers(offset, limit, searchQuery || "",
        // selectedClass || "",
        // selectedSubject || "",
        // selectedMedium || ""
      );
      setData(response.UserData);
      setAvailableDataCount(response.availableDataCount);

      if (offset !== 0 && (offset * limit) > (availableDataCount - 1)) {
        setOffset(offset - 1)
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };



  const bulkUploadQuestions = async (file) => {
    try {
      await AuthService.bulkUploadUsers(file);
      toast.success("Users Uploaded successfully");
      setShowBulkUploadModal(false);

      setOffset(0);
      fetchData();
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const deleteSingleUser = async (id) => {
    try {
      await DynamicService.deleteUser([id]);
      toast.success("User Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const deleteMultipleuser = async () => {
    try {
      if (data?.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item.user_id);
          }
        });
      }
      await DynamicService.deleteUser(itemsToDelete);
      toast.success("Users Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };
  const resendCredentials = async (id) => {
    try {
      await AuthService.resendCredentials([id]);
      toast.success("Credentials Resent successfully");
      setShowResendCredentialsModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };
  const resetPassword = async (id) => {
    try {
      await AuthService.resetPassword([id]);
      toast.success("Password Reset successfully");
      setShowResetPasswordModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };
  const ChangeStatus = async (id, status) => {
    try {
      const response = await AuthService.updateUserStatus(id, status);
      toast.success(response.message);

      var updatedData = data;
      updatedData[updatedData?.findIndex((item) => item.user_id === id)].is_active = status;
      setData(updatedData);

      setShowConfirmationModal(false);
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [offset, selectedClass, selectedMedium, selectedSubject]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (searchQuery != null) {
        fetchData();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchQuery]);
 const removeTimeFromDate = (dateString) => {
    if (!dateString) return "";
    const dateObject = new Date(dateString);
    // Ensure the date is parsed as UTC
    const utcYear = dateObject.getUTCFullYear();
    const utcMonth = dateObject.toLocaleString("default", {
      month: "long",
      timeZone: "UTC",
    });
    const utcDay = dateObject.getUTCDate();
    return `${utcDay} ${utcMonth} , ${utcYear}`;
  };
  return (
    <div>

      <div className="content" data-number="1">
        <div className="mb-3 d-flex justify-content-between align-items-center">
          <h1 className="black fs-18 fw-600 mb-0">STUDENT DETAILS</h1>
          <div className="d-flex">
            <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
            <h4 className="fs-12 fw-500 primary mb-0">Students Details</h4>
          </div>
        </div>
    {details?.user_id ? (
        <div className="table_container">
          <h1 className="black fs-18 fw-600 mb-0">Registration Page Listing</h1>
          <div className=" fs-16 fw-600 mt-3 mb-3 blue">Personal Details</div>
          <div className="rounded shadow ">
            {" "}
            <div style={{ overflowX: "auto" }}>
              <table
                className="table mb-0  table-bordered"
                id="dtHorizontalExample"
                cellSpacing="0"
                width="100%"
              >
                <thead className="border">
                  <tr>
                    <th style={{ width: "20%" }}>First Name</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{details?.firstName}</td>
                    <th style={{ width: "20%" }}>Middle Name</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>
                      {details?.middleName ? (
                        details.middleName
                      ) : (
                        <span className="blue">Not Available...</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: "20%" }}>Last Name</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{details?.lastName}</td>
                    <th style={{ width: "20%" }}>Date of Birth</th>
                    <td style={{ width: "20%" }}>
                      {details?.dateOfBirth}
                    </td>
                  </tr>{" "}
                  <tr>
                    <th style={{ width: "20%" }}>Gender</th>
                    <td style={{ width: "20%" }}>{details?.gender}</td>
                     <th style={{ width: "20%" }}>Register By</th>
                    <td style={{ width: "20%" }}>{details?.registerBy}</td>
                  </tr>{" "}
                 
                  <tr>
                   
                    <th style={{ width: "20%" }}>Register Date</th>
                    <td style={{ width: "20%" }}>{removeTimeFromDate(details?.registrationDate)}</td>
                  </tr>{" "}
                </thead>
              </table>
            </div>
          </div>
          <div className=" fs-16 fw-600 mt-3 mb-3 blue">School Details</div>
          <div className="rounded shadow ">
            <div style={{ overflowX: "auto" }}>
              <table
                className="table mb-0  table-bordered"
                id="dtHorizontalExample"
                cellSpacing="0"
                width="100%"
              >
                <thead className="border">
                  <tr>
                    <th style={{ width: "20%" }}>School Name</th>
                    <td style={{ width: "20%" }}>{details?.schoolName}</td>
                    <th style={{ width: "20%" }}>Medium</th>
                    <td style={{ width: "20%" }}>{details?.medium}</td>
                  </tr>
                  <tr>
                    <th style={{ width: "20%" }}>Class </th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{details?.class_name}</td>
                  </tr>
                 
                </thead>
              </table>
            </div>
          </div>

           <div className=" fs-16 fw-600 mt-3 mb-3 blue">Contact Details</div>
          <div className="rounded shadow ">
            <div style={{ overflowX: "auto" }}>
              <table
                className="table mb-0  table-bordered"
                id="dtHorizontalExample"
                cellSpacing="0"
                width="100%"
              >
                <thead className="border">
                  <tr>
                    <th style={{ width: "20%" }}>Email</th>
                    <td style={{ width: "20%" }}>{details?.email}</td>
                    <th style={{ width: "20%" }}>Mobile</th>
                    <td style={{ width: "20%" }}>{details?.mobile}</td>
                  </tr>
                  <tr>
                    <th style={{ width: "20%" }}>Address</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{details?.addressLineOne}</td>                   
                  </tr>
                 
                </thead>
              </table>
            </div>
          </div>

           <div className=" fs-16 fw-600 mt-3 mb-3 blue">Location Details</div>
          <div className="rounded shadow ">
            <div style={{ overflowX: "auto" }}>
              <table
                className="table mb-0  table-bordered"
                id="dtHorizontalExample"
                cellSpacing="0"
                width="100%"
              >
                <thead className="border">                 
                  <tr>
                    <th style={{ width: "20%" }}>State</th>
                    <td style={{ width: "20%" }}>{details?.state}</td>
                    <th style={{ width: "20%" }}>District</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{details?.district}</td>
                  </tr>{" "}
                  <tr>
                    <th style={{ width: "20%" }}>Taluka</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{details?.taluka}</td>
                    <th style={{ width: "20%" }}>Pin Code</th>
                    <td style={{ width: "20%" }}>{details?.pinCode}</td>
                  </tr>
                </thead>
              </table>
            </div>
          </div>


          <div className="d-flex justify-content-start">
            <div
              className="blue cursor-pointer mt-3 fw-500 fs-14"
              onClick={() => {
                setDetails(null); 
              }}
            >
              {" "}
              <Image src={SvgImages.left_arrow} className="blue mx-3" />
              Back
            </div>
          </div>
        </div>
      ) : (
        <div className="table_container" style={{ display: "block" }}>
          <h1 className="black fs-18 fw-600 mb-0">Students Details</h1>
          <div className="table_title">
            <div className="table_headings mt-2">
              <h1 className="black fs-18 fw-600 mb-0">
                <div className="table_delete_icon" style={{
                  opacity: (data?.findIndex((item) => item.isChecked) === -1) ? 0.3 : 1,
                  pointerEvents: data?.findIndex((item) => item.isChecked) === -1 ? 'none' : 'auto',
                }}
                  onClick={() => {

                    const studentRegistration = user?.setPrivileges?.find(
                      (priv) => priv.parameter === "Students"
                    );

                    if (!studentRegistration?.delete) {

                      toast.warning("You don't have permission to delete question.");
                      return;
                    }

                    const selectedCount = data.filter((item) => item.isChecked).length;
                    if (selectedCount > 0) {
                      setIsMultipleDelete(true);
                      setSelectedQuestionsCount(selectedCount); // Set the count of selected items
                      setShowDeleteModal(true);
                    }
                  }}>
                  <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
                </div>
              </h1>

              <div className="d-flex gap-4 align-items-center ResponsivesectionQuestionlist">
                <div className="position-relative">
                  <input type="search" className="search_box search_bar" placeholder="Search Student" onChange={(e) => {
                    setSearchQuery(e.target.value)
                  }} />
                  <Image src={SvgImages.search} style={ImageFilters.gray} className="search_icon" alt="Search Icon" height="20px" />
                </div>

                <ButtonWithIcon text={"Add Students"} icon={SvgImages.plus}
                  onClick={() => {

                    const studentRegistration = user?.setPrivileges?.find(
                      (priv) => priv.parameter === "Students"
                    );
                    if (studentRegistration?.create) {
                      navigate(RoutesPath.addStudents);
                    } else {
                      toast.warning("You don't have permission to add a Student.")
                    }


                  }} />
                <ButtonWithIcon text={"Bulk Upload Students"} icon={SvgImages.plus} onClick={() => {

                  const studentRegistration = user?.setPrivileges?.find(
                    (priv) => priv.parameter === "Students"
                  );
                  if (studentRegistration?.create) {
                    setShowBulkUploadModal(true)
                  } else {
                    toast.warning("You don't have permission for bulk upload.")
                  }
                }} />
              </div>
            </div>
          </div>

         
          <div style={{ overflowX: "auto" }}>
            <table className="table mb-0" id="dtHorizontalExample" cellSpacing="0" width="100%">
              <thead>
                <tr className="table_heading">
                  <th scope="col" style={{ width: "5%" }}>
                    <label className="d-flex align-items-center justify-content-center">
                      <input className="cursor-pointer" type="checkbox" style={{ height: "16px", aspectRatio: 1 }} checked={data?.length > 0 && data.findIndex((item) => !item.isChecked) === -1} onChange={
                        (value) => {
                          var updatedData = data;
                          updatedData.map((element) => {
                            element.isChecked = value.target.checked;
                          });
                          setData([...updatedData]);
                        }
                      } />
                      <span className="checkmark"></span>
                    </label>
                  </th>
                  <th scope="col" style={{ width: "10%" }}>Sr No.</th>
                  <th scope="col" style={{ width: "10%" }}>First Name</th>
                  <th scope="col" style={{ width: "10%" }}>Last Name</th>
                  <th scope="col" style={{ width: "10%" }}>Email ID</th>
                  <th scope="col" style={{ width: "10%" }}>Class </th>
                  <th scope="col" style={{ width: "10%" }}>Medium</th>
                  <th scope="col" style={{ width: "35%" }}>Package Name</th>
                  <th scope="col" style={{ width: "10%" }}>Registration Date</th>
                  <th scope="col" style={{ width: "10%" }}>Current Status</th>
                  <th scope="col" style={{ width: "10%" }}>Action</th>
                </tr>
              </thead>
              <tbody className="bg_light">
                {data?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <label className="d-flex align-items-center justify-content-center">
                        <input className="cursor-pointer" type="checkbox" checked={item.isChecked || false} style={{ height: "16px", aspectRatio: 1 }}
                          onChange={(value) => {
                            var updatedData = data;
                            updatedData[index].isChecked = value.target.checked;
                            setData([...updatedData]);
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td>{(limit * (offset)) + (index + 1)}</td>
                    <td>{item.firstName}</td>
                    <td>{item.lastName}</td>
                    <td>{item.email}</td>
                    <td>{item.class_name}</td>
                    <td>{item.medium}</td>
                    <td>{item.packages.map((packageItem) => packageItem.packageName).join(", ")}</td>
                    <td>{item.registrationDate}</td>
                    {/* <td>{item.currentStatus}</td> */}
                    {/* <td><h2 className="threeLineText fs-14 fs-500 mb-0 w-100" title={item.question.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ')} >{item.question.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ')}</h2></td> */}
                    <td>
                      <label className="switch" data-bs-target="#change_status" data-bs-toggle="modal">
                        <input type="checkbox" checked={item.is_active}
                          onChange={() => {

                            const studentRegistration = user?.setPrivileges?.find(
                              (priv) => priv.parameter === "Students"
                            )
                            if (!studentRegistration?.update) {

                              toast.warning("You don't have permission to update the status.");
                              return;
                            }

                            setShowConfirmationModal(true);
                            setStatusChangeData(item);
                          }}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>
                    <td>
                      <div className="d-flex gap_8">
                        <button title="Edit" onClick={() => {

                          const studentRegistration = user?.setPrivileges?.find(
                            (priv) => priv.parameter === "Students"
                          );

                          if (!studentRegistration?.update) {

                            toast.warning("You don't have permission to edit student.");
                            return;
                          }

                          navigate(RoutesPath.editStudents, { state: item });
                        }} className="edit_icons cursor-pointer">
                          <Image src={SvgImages.edit} style={ImageFilters.green} className="add_icons" alt="Edit Icon" />

                        </button>
                        <button title="Delete" className="delete_icons cursor-pointer" onClick={() => {

                          const studentRegistration = user?.setPrivileges?.find(
                            (priv) => priv.parameter === "Students"
                          );

                          if (!studentRegistration?.delete) {

                            toast.warning("You don't have permission to delete student.");
                            return;
                          }

                          setDeleteId(item.user_id);
                          setIsMultipleDelete(false);
                          setShowDeleteModal(true);
                        }}
                        >
                          <Image src={SvgImages.deleteIcon} style={ImageFilters.red} data-bs-target="#delete-modal" data-bs-toggle="modal" alt="Delete Icon" />
                        </button>
                        <button title="resendCredentials" className="delete_icons cursor-pointer" onClick={() => {

                          const studentRegistration = user?.setPrivileges?.find(
                            (priv) => priv.parameter === "Students"
                          );

                          if (!studentRegistration?.delete) {

                            toast.warning("You don't have permission to resend Credentials .");
                            return;
                          }

                          setDeleteId(item.user_id);
                          setShowResendCredentialsModal(true);
                        }}
                          style={{ backgroundColor: "#FFEBDA" }}
                        >
                          <Image src={SvgImages.resendCredentials} style={ImageFilters.peach} data-bs-target="#delete-modal" data-bs-toggle="modal" alt="resendCredentials" />
                        </button>
                        <button title="resetPassword" className="delete_icons cursor-pointer" onClick={() => {

                          const studentRegistration = user?.setPrivileges?.find(
                            (priv) => priv.parameter === "Students"
                          );

                          if (!studentRegistration?.delete) {

                            toast.warning("You don't have permission to Reset Password.");
                            return;
                          }

                          setDeleteId(item.user_id);
                          setShowResetPasswordModal(true);
                        }}
                          style={{ backgroundColor: "#E2E2E2" }}
                        >
                          <Image src={SvgImages.resetPassword} style={ImageFilters.black} data-bs-target="#delete-modal" data-bs-toggle="modal" alt="resetPassword" />
                        </button>
                        <button title="view" className="delete_icons cursor-pointer"
                          onClick={() => {

                            const studentRegistration = user?.setPrivileges?.find(
                              (priv) => priv.parameter === "Students"
                            );

                            if (!studentRegistration?.read) {

                              toast.warning("You don't have permission to View.");
                              return;
                            }

                        setDetails(item);
                          }}
                          style={{ backgroundColor: "#EDF2FF" }}
                        >
                          <Image src={SvgImages.view} style={ImageFilters.blue} data-bs-target="#delete-modal" data-bs-toggle="modal" alt="view" />
                        </button>
                      </div>
                    </td>
                    <td className="text-capitalize blue">{item.status == "approved" ? <div className="text-success">{item.status}</div> : <div>{item.status == "rejected" ? <div className="text-danger">{item.status}</div> : <div className="blue">{item.status}</div>}</div>}</td>

                  </tr>
                ))}
              </tbody>
            </table>


          </div>
          {generatePaginationFooter(availableDataCount, limit, offset, setOffset)}
        </div>
         )}
      </div>


      {/* Delete Questions Modal */}
      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={isMultipleDelete ? `Are you sure you want to delete selected ${selectedQuestionsCount} question${selectedQuestionsCount > 1 ? 's' : ''}?` : "Are you sure you want to delete this question?"}
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => { isMultipleDelete ? deleteMultipleuser() : deleteSingleUser(deleteId) }}
        theme={ConfirmationModalTheme.error}
      />

      {/* Change Status Modal */}
      <ConfirmationModal
        showModal={showConfirmationModal}
        setShowModal={setShowConfirmationModal}
        text={"Are you sure want to change the status?"}
        icon={SvgImages.exclamation_mark} // Specify the path to your delete icon
        rightClickAction={() => { ChangeStatus(getStatusChangeData.user_id, !getStatusChangeData.is_active) }}
        theme={ConfirmationModalTheme.warning}
      />

      {/* Resend Credentials Modal */}
      <ConfirmationModal
        showModal={showResendCredentialsModal}
        setShowModal={setShowResendCredentialsModal}
        text={"Are you sure want to resend credentials?"}
        icon={SvgImages.exclamation_mark} // Specify the path to your delete icon
        rightClickAction={() => { resendCredentials(deleteId) }}
        theme={ConfirmationModalTheme.warning}
      />

      {/* Reset Password Modal */}
      <ConfirmationModal
        showModal={showResetPasswordModal}
        setShowModal={setShowResetPasswordModal}
        text={"Are you sure want to reset password?"}
        icon={SvgImages.exclamation_mark} // Specify the path to your delete icon
        rightClickAction={() => { resetPassword(deleteId) }}
        theme={ConfirmationModalTheme.warning}
      />


      <BulkUploadModal
        showModal={showBulkUploadModal}
        setShowModal={setShowBulkUploadModal}
        onSuccess={(file) => bulkUploadQuestions(file)}
      />
    </div>
  );
};

export default ViewStudents;

const BulkUploadModal = ({ showModal, setShowModal, onSuccess }) => {
  const fileTypes = ["csv", "xlsx", "xls"];

  const handleChange = (file) => {
    onSuccess(file);
  };

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      dialogClassName="my-0"
      centered // Center the modal vertically and horizontally
      aria-labelledby="exampleModalToggleLabel2"
      contentClassName="p-0 bg-transparent border-0 shadow-none m-0"
    >
      <ModalBody className="p-0">
        <div className="w-100 d-flex flex-column">
          <div className="modal-content p-4">
            <div className="d-flex gap-3 flex-column justify-content-center align-items-center">
              <h1 className="black fs-18 fw-600 mb-0">Bulk Upload</h1>

              <div className="file_select_box2 w-100 d-flex gap-1 flex-column justify-content-center align-items-center p-4">
                <FileUploader handleChange={handleChange} name="file" types={fileTypes} onTypeError={
                  (error) => {
                    toast.error(error);
                  }
                } dropMessageStyle={{ backgroundColor: '#c2c2c2', color: "transparent", border: 0 }}>
                  <div className="d-flex gap-2 flex-column justify-content-center align-items-center">
                    <div className="d-flex gap-2 flex-column justify-content-center align-items-center">
                      <Image src={SvgImages.select_file} style={{ height: 36, filter: ImageFilters.lightGrey.filter }} />
                      <h2 className="primary fs-14  fw-500 mb-0">Drag and drop file here</h2>
                    </div>

                    <h3 className="subText fs-14  fw-500 mb-0">OR</h3>

                    <ButtonWithIcon text={"Browse Files"} icon={SvgImages.file} />

                    <h3 className="subText fs-12  fw-400 mb-0 mt-2 text-center">We only support CSV and Excel format here. Here's a sample of
                      how it should look like</h3>
                  </div>
                </FileUploader>
                <a href={ApiConstants.FILE_FETCH_URL + "Sample/BulkUploadStudents.xlsx"} className="primary fs-14 fw-600 mb-0" style={{ borderBottom: "1px solid #14489f", zIndex: 999 }}>Click to Download Sample File</a>
              </div>

            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};